<template>
  <div>
    <input
      ref="fileInputRef"
      class="d-none"
      type="file"
      :accept="accept"
    />

    <div
      ref="dropzoneRef"
      class="dropzone dropzone-file-area"
      @click="pickFile"
    >
      <h3 class="dropzone-icon">
        <i
          class="fa fa-2x text-primary"
          :class="`fa-${uploadIcon}`"
        ></i>
      </h3>
      <p class="mb-0">
        {{ uploadText }}
      </p>
      <p v-if="uploadHelperText" class="mb-0 text-muted small">
        {{ uploadHelperText }}
      </p>
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted, ref } from 'vue'
import $ from 'jquery'

export default {
  name: 'UploadDropzone',
  props: {
    uploadIcon: {
      type: String,
      require: true
    },
    uploadText: {
      type: String,
      require: true
    },
    uploadHelperText: {
      type: String
    },
    accept: {
      type: String,
      require: true
    }
  },
  emits: ['change-file'],
  setup (props, { emit, expose }) {
    const dropzoneRef = ref(null)
    const fileInputRef = ref(null)

    const pickFile = () => {
      $(fileInputRef.value).trigger('click')
    }

    const changeFile = (files) => {
      if (files[0]) {
        emit('change-file', files[0])
      }
    }

    const reset = () => {
      $(fileInputRef.value).val(null)
    }

    onMounted(() => {
      $(dropzoneRef.value)
        .on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
          e.preventDefault()
          e.stopPropagation()
        })
        .on('dragover dragenter', () => {
          $(dropzoneRef.value).addClass('is-dragover')
        })
        .on('dragleave dragend drop', () => {
          $(dropzoneRef.value).removeClass('is-dragover')
        })
        .on('drop', e => {
          changeFile(e.originalEvent.dataTransfer.files)
        })

      $(fileInputRef.value).on('change', e => {
        changeFile(e.target.files)
      })
    })

    onUnmounted(() => {
      $(dropzoneRef.value).off('drag dragstart dragend dragover dragenter dragleave drop')
      $(fileInputRef.value).off('change')
    })

    expose({
      reset
    })

    return {
      dropzoneRef,
      fileInputRef,

      pickFile
    }
  }
}
</script>
